<template>
    <v-form @submit.prevent="updateRunner" novalidate>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>BIEGOWE</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="accent" small v-if="isActiveRunner || isAdmin" @click.prevent="updateMode = !updateMode">edytuj</v-btn>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg3>
        <v-list two-line>
          <runner-data-field
            :editable="updateMode"
            label="Staż biegowy"
            required
            v-model="form.training_practice"
            :objValue="runner.training_practice"
            :formErrors="formErrors"
            :field="'training_practice'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Tygodniowy kilometraż"
            required
            v-model="form.weekly_mileage"
            :objValue="runner.weekly_mileage"
            :formErrors="formErrors"
            :field="'weekly_mileage'"></runner-data-field>
          <runner-data-field
            :class="{bigger: updateMode}"
            :editable="updateMode"
            label="Aktualny cel główny"
            required
            v-model="form.main_goal"
            :objValue="runner.main_goal"
            :formErrors="formErrors"
            :field="'main_goal'">

              <template slot-scope="{ error, errorMessages, label }">
                <v-textarea
                              :label="label + '*'"
                              v-model="form.main_goal"
                              :error="error"
                              :error-messages="errorMessages"
                />
              </template>
          </runner-data-field>
          <runner-data-field
            :class="{bigger: updateMode}"
            :editable="updateMode"
            label="Aktualne cele dodatkowe"
            v-model="form.additional_goal"
            :objValue="runner.additional_goal"
            :formErrors="formErrors"
            :field="'additional_goal'">
              <template slot-scope="{ error, errorMessages, label }">
                <v-textarea
                              :label="label"
                              v-model="form.additional_goal"
                              :error="error"
                              :error-messages="errorMessages"
                />
              </template>
          </runner-data-field>
        </v-list>
      </v-flex>

      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg0>
        <v-list two-line>
          <runner-data-field
            :editable="updateMode"
            label="Ilość treningów"
            description='Ilość dni treningowych w tygodniu'
            required
            v-model="form.training_days_number"
            :objValue="runner.training_days_number"
            :formErrors="formErrors"
            :field="'training_days_number'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Dni treningowe"
            description="Proponowane dni treningowe w tygodniu"
            required
            v-model="form.training_days"
            :objValue="runner.training_days ? runner.training_days.join(', ') : ''"
            :formErrors="formErrors"
            :field="'training_days'">
                  <template slot-scope="{ error, errorMessages, label}">
                    <v-select
                      :menu-props="{ maxHeight: '400' }"
                      v-model="form.training_days"
                      :error="error"
                      :label="label + '*'"
                      :error-messages="errorMessages"
                      multiple
                      :items="['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela']">
                    </v-select>
                  </template>
          </runner-data-field>

          <runner-data-field
            :editable="updateMode"
            label="Czas sesji treningowej"
            description="Najdłuższy czas jednej sesji treningowej"
            v-model="form.training_session_length"
            :objValue="runner.training_session_length"
            :formErrors="formErrors"
            :field="'training_session_length'"></runner-data-field>

          <runner-data-field
            :editable="updateMode"
            label="Przeciwwskazania"
            description="Przeciwwskazania do uprawniania sportu"
            required
            v-model="form.contraindications"
            :objValue="runner.contraindications"
            :formErrors="formErrors"
            :field="'contraindications'"></runner-data-field>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg3>
        <v-btn v-if="updateMode" type="submit" color="primary">Zapisz</v-btn>
      </v-flex>
    </v-layout>

  </v-form>
</template>

<script>
import {updateRunnerData} from './api'
import iziToast from 'izitoast'
import { mapGetters } from 'vuex'
import RunnerDataField from './RunnerDataField'

export default {
  components: {RunnerDataField},
  validators: {},
  props: {
    runner: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      updateMode: false,
      form: {},
      formErrors: {}
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isActiveRunner'])
  },
  created () {
    this.form = {...this.runner}
  },
  watch: {
    'runner': function (oldVar, newVar) {
      this.form = {...this.runner}
    }
  },
  methods: {
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerData(this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-updated', data)
            iziToast.show({
              message: 'Konto zawodnika zostało edytowane.',
              color: 'green'
            })
            this.updateMode = false
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>
<style>
.bigger .v-list__tile{
  height: 155px;
}
</style>



// WEBPACK FOOTER //
// src/runners/RunnerDataRunning.vue